<template>
    <div class="cat-carousel scrolltome">
        <div class="carousel-container ambientes-container">
            <carousel v-if="finishes"
                      :navigationEnabled="true"
                      :perPageCustom="[[300, 1], [768, 2], [1024, 3], [1280, 4], [1661, 6]]"
                      :autoplayTimeout="3000"
                      :speed="700"
                      :autoplay="true"
                      :loop="true"
                      :paginationEnabled="false">
                <slide v-for="(categorie, index) in categories" :key="categorie.name + 'catcarousel'">
                    <router-link :to="`/acabamentos/${categorie.url || categorie.id}`"
                                 @click.native="scrollIntoProducts(index)"
                                 :class="{active: currentCategorie === index + 1}"
                                 class="item-product">
                        <lazy-image v-if="categorie.file !== null"
                                    :circle="true"
                                    width="100px"
                                    height="100px"
                                    center="0 auto 10px auto"
                                    :image="categorie.file"/>
                        <h3 class="item-finishes__title">{{categorie.name}}</h3>
                    </router-link>
                </slide>
            </carousel>
            <carousel v-if="product"
                      :navigationEnabled="true"
                      :autoplayTimeout="3000"
                      :speed="700"
                      :autoplay="true"
                      :loop="true"
                      :perPage="6"
                      :perPageCustom="[[300, 1], [768, 2], [1024, 3], [1280, 4], [1661, 6]]"
                      :paginationEnabled="false">
                <slide v-for="(categorie, index) in categories" :key="categorie.name + 'catcarousel'">
                    <router-link :to="`/produtos/${categorie.url || categorie.id}`"
                                 @click.native="scrollIntoProducts(index)"
                                 :class="{active: currentCategorie === index + 1}"
                                 class="item-product">
                        <div class="item-product__holder"
                             :class="{big: bigImg}">
                            <lazy-image v-if="categorie.file !== null"
                                        :image="categorie.file"/>
                        </div>
                        <h3 class="item-product__title">{{categorie.name}}</h3>
                    </router-link>
                </slide>
            </carousel>
            <carousel v-if="promocoes"
                      :navigationEnabled="true"
                      :autoplayTimeout="3000"
                      :speed="700"
                      :autoplay="true"
                      :loop="true"
                      :perPage="6"
                      :perPageCustom="[[300, 1], [768, 2], [1024, 3], [1280, 4], [1661, 6]]"
                      :paginationEnabled="false">
                <slide v-for="(categorie, index) in categories" :key="categorie.name + 'catcarousel'">
                    <router-link :to="`/promocoes/${categorie.url || categorie.id}`"
                                 @click.native="scrollIntoProducts(index)"
                                 :class="{active: currentCategorie === index + 1}"
                                 class="item-product">
                        <div class="item-product__holder"
                             :class="{big: bigImg}">
                            <lazy-image v-if="categorie.file !== null"
                                        :image="categorie.file"/>
                        </div>
                        <h3 class="item-product__title">{{categorie.name}}</h3>
                    </router-link>
                </slide>
            </carousel>
            <carousel v-if="environments"
                      :navigationEnabled="true"
                      :autoplayTimeout="3000"
                      :speed="700"
                      :autoplay="true"
                      class="amb-carousel"
                      :loop="true"
                      :perPage="2"
                      :perPageCustom="[[300, 1], [768, 2], [1024, 2], [1280, 2], [1661, 2]]"
                      :paginationEnabled="false">
                <slide v-for="(categorie, index) in categories" :key="categorie.name + 'catcarousel'">
                    <router-link :to="`/ambientes/${categorie.friendly_url || categorie.id}`"
                                 @click.native="scrollIntoProducts(index)"
                                 :class="{active: currentCategorie === index + 1}"
                                 class="item-product">
                        <div class="item-product__holder"
                             :class="{big: bigImg}">
                            <img v-if="categorie.file !== null"
                                        class="item-product__img"
                                        :class="{big: bigImg}"
                                        :src="categorie.file.permalink"/>
                        </div>
                        <h3 class="item-product__title amb-title">{{categorie.name}}</h3>
                    </router-link>
                </slide>
            </carousel>
        </div>

        <div v-if="finishes" class="container filter-content">
            <!--            <div class="results">Mostrando<span v-if="pages"> {{current + 1}}-{{pages}} de</span> {{showProducts.length}} acabamentos</div>-->
        </div>

        <div v-if="product" class="container filter-content">
            <!--            <div class="results">Mostrando<span v-if="pages"> {{current + 1}}-{{pages}} de</span> {{showProducts.length}} produtos</div>-->
        </div>

        <div v-if="environments" class="container filter-content">
            <!--            <div class="results">Mostrando<span v-if="pages"> {{current + 1}}-{{pages}} de</span> {{showProducts.length}} ambientes</div>-->
        </div>
    </div>
</template>

<script>
    import {Carousel, Slide} from 'vue-carousel';
    import LazyImage from "./LazyImage";

    export default {
        name: "InstaCarousel",
        props: ['categories', 'finishes', 'product', 'promocoes', 'bigImg', 'environments', 'pages', 'products'],
        data() {
            return {
                path: '',
                activeProduct: 0,
                currentPage: null,
                showProducts: [],
                inactive: null,
                currentCategorie: 1,
            }
        },
        components: {
            Carousel,
            Slide,
            LazyImage
        },
        watch: {
            products() {
                this.showProducts = this.products;
            },
            current() {
                this.currentCategorie = this.current;
            }
        },
        methods: {
            changeActive(index) {
                this.activeProduct = index;
            },
            scrollIntoProducts(index) {
                const products = document.querySelector('.page-scroll');
                this.currentCategorie = index + 1;
                products.scrollIntoView({
                    block: 'start',
                    behavior: 'smooth'
                })
            }
        },
        mounted() {
            this.path = this.$route.fullPath;
        },
    }
</script>

<style lang="scss" scoped>
    .cat-carousel {
        position: relative;
        margin: 60px auto 30px auto;
    }

    .item-finishes {
        padding: 20px;

        &__img {
            width: 100px;
            height: 100px;
            object-fit: cover;
            margin: 0 auto 15px auto;
            border-radius: 50%;
        }

        &__title {
            height: 30px;
            overflow: hidden;
            font-size: 1rem;
            font-family: 'Poppins', Arial, sans-serif;
            font-weight: 300;
            text-align: center;
            color: #2b2b2b;
        }
    }

    .item-product {
        display: block;
        padding: 40px 20px;
        border: 1px solid transparent;

        &:hover {
            border: 1px solid #e5e5e5;
        }

        &.active {
            border: 1px solid #e5e5e5;
        }

        &__img {
            margin: 0 auto 15px auto;
        }

        &__title {
            font-size: 1rem;
            font-family: 'Poppins', Arial, sans-serif;
            font-weight: 300;
            text-align: center;
            color: #2b2b2b;
        }

        &__holder {
            height: 75px;
            width: 60px;
            margin: 0 auto;
            display: flex;
            justify-content: flex-end;
            flex-direction: column;
        }
    }

    .carousel-container {
        max-width: 1140px;
        margin: 0 auto;
    }

    .filter-content {
        display: flex;
        justify-content: flex-end;
        margin-top: 20px;
        padding-top: 40px;
        border-top: 1px solid rgba(0, 0, 0, .3);
        max-width: 1140px;
    }

    .filter {
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding: 10px 100px 10px 15px;
        border: 1px solid #babfc2;
        border-radius: 4px;
        margin-left: -15px;
        font-family: "Open Sans";
        font-size: 0.875rem;
        color: #2b2b2b;
        position: relative;
        cursor: pointer;

        &__chevron {
            position: absolute;
            right: 15px;
            transform: rotate(90deg);
            width: 10px;
            height: 10px;
        }
    }

    .results {
        float: right;
        font-family: "Open Sans";
        font-size: 0.875rem;
        color: #2b2b2b;
        margin-right: -15px;
    }

    .big {
        width: 144px !important;
        height: 144px !important;
    }

    .amb-title {
        width: 80px;
        margin: 0 auto;
    }

    .amb-carousel {
        max-width: 600px;
        margin: 0 auto;
    }

    @media only screen and(max-width: 1366px) {
        .carousel-container {
            max-width: 840px;
        }
    }

    @media only screen and (max-width: 1200px) {
        .filter-content {
            display: flex;
            justify-content: space-between;
            margin-top: 50px;
            padding-top: 40px;
            border-top: 1px solid rgba(0, 0, 0, .3);
            max-width: 960px;
        }
    }

    @media only screen and (max-width: 768px) {
        .carousel-container {
            max-width: 560px;
        }

        .filter-content {
            display: flex;
            justify-content: space-between;
            margin-top: 50px;
            padding-top: 40px;
            border-top: 1px solid rgba(0, 0, 0, .3);
            max-width: 640px;
        }
    }

    @media only screen and (max-width: 767px) {
        .carousel-container {
            width: 170px;
            margin: 0 auto;
        }

        .item-product {
            max-width: 170px;
        }

        .filter-content {
            flex-direction: column;
            max-width: calc(100% - 30px);
        }

        .filter {
            margin-bottom: 20px;
            margin-left: 0;
        }

        .results {
            text-align: right;
            margin-right: 0px;
        }
    }
</style>